import { Injectable } from '@angular/core';
import { SlWapiService } from './sl-wapi.service';
import { ICancellablePromise } from 'src/app/types/cancellable-promise';
import prj4, { TemplateCoordinates } from 'proj4';
import { LngLat } from 'mapbox-gl';
import { SLLayer } from '../sl-layer';

export type PrjTypeAheadParams = {
	terms: string;
	auth: 'epsg' | 'esri' | '*';
	crs: 'geogcs' | 'projcs' | '*';
	sr?: boolean;
	deps?: boolean;
	proj4?: boolean;
	units?: boolean;
}
export type ProjectionCodeParams = {
	auth: 'epsg' | 'esri';
	id: string;
	crs: 'geogcs' | 'projcs' | '*';
	sr?: boolean;
	deps?: boolean;
	proj4?: boolean;
	units?: boolean;
}
export type XYCoord = {
	x: number;
	y: number
}
export type XYTuple = [number, number];

export type XYZCoord = {
	x: number;
	y: number;
	z: number;
};
export type XYZTuple = [number, number, number];

@Injectable({
	providedIn: 'root'
})
export class ProjectionService {

	static RegisterLayerSRS(layer: SLLayer) {
		const srs = layer.srs;
		if (srs === null) {
			return;
		}
		if (layer.isPLayer === true) {
			prj4.defs('PLayer:' + layer.plid, srs);
		}
		prj4.defs('Layer:' + layer.id, srs);
	}
	constructor(private wapi: SlWapiService) { }

	MakeWith(params:any) {
		const withParam = [];
		if (params.sr === true) {
			withParam.push('sr');
		}
		if (params.proj4 === true) {
			withParam.push('proj4');
		}
		if (params.deps === true) {
			withParam.push('deps');
		}
		if (params.units === true) {
			withParam.push('units');
		}
		return withParam.join(',');
	}

	GetPojections(params: PrjTypeAheadParams): ICancellablePromise {
		const withParam = [];
		

		return this.wapi.Post('layers/projections/typeahead/', {
			terms: params.terms,
			auth: params.auth,
			crs: params.crs,
			with: this.MakeWith(params)
		})
	}
	GetByCode(params: ProjectionCodeParams) {
		return this.wapi.Post('layers/projections/get-by-code/', {
			auth: params.auth,
			id:params.id,
			crs: params.crs,
			with: this.MakeWith(params)
		})
	}
	GetProjector(fromSRS: string, toSRS: string) {
		return prj4(fromSRS, toSRS);
	}
	ProjectSRS2SRS(fromCoord: XYCoord | XYTuple | XYZCoord | XYZTuple, fromSRS, toSRS) {
		return prj4(fromSRS, toSRS, fromCoord);
	}
	ReverseSRS2LngLat(fromCoord: XYCoord | XYTuple | XYZCoord | XYZTuple, fromSRS, toSRS) {
		const llCoord = prj4(fromSRS, toSRS, fromCoord);
		return new LngLat(llCoord[1], llCoord[0]);
	}

}
